import { render, staticRenderFns } from "./HighRiskChart.vue?vue&type=template&id=67d17a8c&lang=html&"
import script from "./HighRiskChart.vue?vue&type=script&lang=js&"
export * from "./HighRiskChart.vue?vue&type=script&lang=js&"
import style0 from "./HighRiskChart.vue?vue&type=style&index=0&id=67d17a8c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports